
import { ChevronDownIcon } from 'vue-feather-icons'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Accordion',
  components: {
    ChevronDownIcon
  },
  props: {
    // eslint-disable-next-line vue/require-prop-types
    items: {
      default: [],
      required: true
    },
    // eslint-disable-next-line vue/require-prop-types
    open: {
      default: -1,
      required: false
    }
  },
  data: () => ({
    openIndex: -1
  }),
  created () {
    this.openIndex = this.open
  },
  mounted () {
    this.handleContactForm()
  },
  methods: {
    toggle (index) {
      this.openIndex = this.openIndex === index ? -1 : index
    },
    handleContactForm () {
      const self = this
      const contactLink = document.querySelectorAll('[class="FWTrigger"]')
      for (let i = 0; i < contactLink.length; i++) {
        contactLink[i].addEventListener('click', function (event) {
          event.preventDefault()
          self.$bus.$emit('OPEN_FW')
        })
      }
    }
  }
}
